<template>

  <div class="editorial">

     <link href='http://www.chinacirculation.org/Areas/201607080003/content/css/comm.css' rel="stylesheet" type="text/css"/> 
    <link href='http://www.chinacirculation.org/Areas/201607080003/content/css/style.css' rel="stylesheet" type="text/css"/> 

    <div class="editorial_nav">
      <div class="editorial_txt">
        <div class="iconfont iconhomeicon evolution_tu" style="margin-right: 5px;"></div>
        <div class="editorial_txt2" style="cursor: pointer;" @click="tiao">
          首页 <span class="span1">></span> <span class="span2">编委会</span>
        </div>
      </div>
      <div class="editorial_left">
        <div class="express_rtitle">
          <div class="waike">编委会</div>
          <div class="waixian"></div>
        </div>
        <div class="express_nav2r">

          <!-- <div class="express_list2" v-for="(item,index) in list" :key="index">
            <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop(1,item.contentId)" @mouseout="addtop(2,item.contentId)"></div>
            <div class="express_wen" @mouseover="addtop(1,item.contentId)" @mouseout="addtop(2,item.contentId)" style="overflow: hidden;width: 96%;">
              <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.title}}</span><span
                  style="max-width: 30%; float: right;text-align: right;">{{item.addDate}}</span></div>
            </div>
          </div> -->
        <div class="editorial_txt3">

          <div class="tuxq" v-html="list3.content">

          </div>
					<div id="divContent" v-if="false" >
						
						<div class="pBt">编委会</div>
							<p class="pBtbianwei">《中国循环杂志》第六届编辑委员会名单</p>
							<p style="font-weight: bold;">（按拼音字母排序）</p>
							<div class="divContentCont">
								<p>顾问1</p>
								<ul>

									<li class="contLi">
										<a href="##" style="color:#3393e7">陈在嘉</a>
										<ul style="position: absolute;top: -9px;left:4%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450092807176799704445.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=8" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/zaijia-chen/542fe106dabfaed7c7c4be6d" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									

									<li><a href="##">程显声</a></li>
									<li><a href="##">戴汝平</a></li>
									<li><a href="##">丁金凤</a></li>
									<li><a href="##">郭静萱</a></li>
									<li><a href="##">胡大一</a></li>
									<li><a href="##">林曙光</a></li>
									<li><a href="##">刘国树</a></li>
									<li><a href="##">刘玉清</a></li>
									<li><a href="##">戚文航</a></li>
									<li><a href="##">钱方毅</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">沈卫峰</a>
										<ul style="position: absolute;top: 25%;left:68%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451047152662794592213.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=71" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/weifeng-shen/542f5260dabfaed7c7c3fcce" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">宋来凤</a></li>
									<li><a href="##">唐朝枢</a></li>
									<li><a href="##">王天佑</a></li>
									<li><a href="##">郑德裕</a></li>
									<li><a href="##">朱晓东</a></li>
									<div style="clear: both;"></div>
								</ul>
							</div>
							<div class="divContentCont">
								<p>名誉主编</p>
								<ul>
									<li class="contLi">
										<a href="##" style="color:#3393e7">胡盛寿</a>
										<ul style="position: absolute;top: -8px;left:4%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450134802051058649509.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=90" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/shengshou-hu/5429adb4dabfaec7081a5aaa" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<div style="clear: both;"></div>
								</ul>
							</div>
							<div class="divContentCont">
								<p>主编</p>
								<ul>
									<li class="contLi">
										<a href="##" style="color:#3393e7">高润霖</a>
										<ul style="position: absolute;top: -8px;left:4%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450110319470334073526.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=9" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/run-lin-gao/54059761dabfae91d3ff5b42" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<div style="clear: both;"></div>
								</ul>
								
							</div>
							<div class="divContentCont">
								<p>副主编</p>
								<ul>
									<li class="contLi">
										<a href="##" style="color:#3393e7">陈纪林</a>
										<ul style="position: absolute;top: -6px;left:4%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450193655482815555357.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=10" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/jilin-chen/5405ea34dabfae450f3e0d20" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">张 运</a></li>
									<li><a href="##">顾东风</a></li>
									<li><a href="##">韩雅玲</a></li>
									<li><a href="##">葛均波</a></li>
									<li><a href="##">柯元南</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">杨跃进</a>
										<ul style="position: absolute;top: -6px;left:39%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451097189838057934837.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=11" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/yuejin-yang/542f82c6dabfae3f1d5998f3" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">朱文玲</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">郑&nbsp;哲</a>
										<ul style="position: absolute;top: -8px;left:50.5%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451126913537994027376.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=72" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/zhe-zheng/53f4bf4edabfaedce877b58f" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<div style="clear: both;"></div>
								</ul>
							</div>
							<div class="divContentCont">
								<p>编委</p>
								<ul>
									<li><a href="##">敖虎山</a></li>
									<li><a href="##">蔡　军</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">陈纪林</a>
										<ul style="position: absolute;top: -6px;left:16%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450193655482815555357.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=10" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/jilin-chen/5405ea34dabfae450f3e0d20" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">陈纪言</a></li>
									<li><a href="##">陈柯萍</a></li>
									<li><a href="##">陈兰英</a></li>
									<li><a href="##">陈伟伟</a></li>
									<li><a href="##">陈&nbsp;曦</a></li>
									<li><a href="##">陈韵岱</a></li>
									<li><a href="##">党爱民</a></li>

									<li><a href="##">董念国</a></li>
									<li><a href="##">董吁钢</a></li>
									<li><a href="##">窦克非</a></li>
									<li><a href="##">杜玉环</a></li>
									<li><a href="##">方&nbsp;全</a></li>
									<li><a href="##">凤&nbsp;玮</a></li>
									<li><a href="##">傅向华</a></li>

									<li><a href="##">高长青</a></li>
									<li><a href="##">高传玉</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">高润霖</a>
										<ul style="position: absolute;top: 9%;left:16%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450110319470334073526.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=9" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/run-lin-gao/54059761dabfae91d3ff5b42" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">高　炜</a></li>
									<li><a href="##">葛均波</a></li>
									<li><a href="##">顾东风</a></li>
									<li><a href="##">郭继鸿</a></li>

									<li><a href="##">韩雅玲</a></li>
									<li><a href="##">何&nbsp;奔</a></li>
									<li><a href="##">何建国</a></li>
									<li><a href="##">何&nbsp;耀</a></li>
									<li><a href="##">何作祥</a></li>
									<li><a href="##">黑飞龙</a></li>
									<li><a href="##">洪&nbsp;葵</a></li>

									<li><a href="##">侯晓彤</a></li>
									<li><a href="##">胡奉环</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">胡盛寿</a>
										<ul style="position: absolute;top: 14%;left:70%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450134802051058649509.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=90" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/shengshou-hu/5429adb4dabfaec7081a5aaa" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">华&nbsp;伟</a></li>
									<li><a href="##">黄从新</a></li>
									<li><a href="##">黄德嘉</a></li>
									<li><a href="##">黄国英</a></li>
									<li><a href="##">黄&nbsp;洁</a></li>
									<li><a href="##">黄&nbsp;岚</a></li>
									<li><a href="##">惠汝太</a></li>
									<li><a href="##">贾绍斌</a></li>
									<li><a href="##">蒋立新</a></li>
									<li><a href="##">蒋世良</a></li>
									<li><a href="##">蒋雄京</a></li>
									<li><a href="##">金征宇</a></li>
									<li><a href="##">荆志成</a></li>
									<li><a href="##">景在平</a></li>
									

									
									<li><a href="##">柯元楠</a></li>
									<li><a href="##">李&nbsp;保</a></li>
									<li><a href="##">李光伟</a></li>
									<li><a href="##">李虹伟</a></li>
									<li><a href="##">李建军</a></li>
									<li><a href="##">李&nbsp;浪</a></li>
									<li><a href="##">李立环</a></li>
									<li><a href="##">李南方</a></li>
									<li><a href="##">李守军</a></li>
									<li><a href="##">李为民</a></li>
									<li><a href="##">李&nbsp;卫</a></li>
									<li><a href="##">李小鹰</a></li>
									<li><a href="##">李新利</a></li>
									<li><a href="##">李一石</a></li>
									<li><a href="##">李&nbsp;莹</a></li>
									<li><a href="##">林金秀</a></li>
									<li><a href="##">刘&nbsp;健</a></li>
									<li><a href="##">刘锦纷</a></li>
									<li><a href="##">刘&nbsp;进</a></li>
									<li><a href="##">刘&nbsp;静</a></li>
									<li><a href="##">刘梅林</a></li>
									<li><a href="##">刘&nbsp;苏</a></li>
									<li><a href="##">刘文玲</a></li>
									<li><a href="##">柳志红</a></li>
									<li><a href="##">龙&nbsp;村</a></li>
									<li><a href="##">卢长林</a></li>
									<li><a href="##">陆国平</a></li>
									<li><a href="##">吕&nbsp;滨</a></li>
									<li><a href="##">马长生</a></li>
									<li><a href="##">马&nbsp;坚</a></li>
									<li><a href="##">马依彤</a></li>
									<li><a href="##">孟宪敏</a></li>
									<li><a href="##">孟&nbsp;旭</a></li>
									<li><a href="##">牟建军</a></li>
									<li><a href="##">宁田海</a></li>
									<li><a href="##">浦介麟</a></li>
									<li><a href="##">钱菊英</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">乔树宾</a>
										<ul style="position: absolute;top: 44%;left:4%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370450256458480296431154.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=7" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/shubin-qiao/53f42fdfdabfaee43ebe4ee4" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">秦&nbsp;勤</a></li>
									<li><a href="##">舒&nbsp;畅</a></li>
									<li><a href="##">宋云虎</a></li>
									<li><a href="##">孙寒松</a></li>
									<li><a href="##">孙宁玲</a></li>
									<li><a href="##">谭&nbsp;宁</a></li>
									<li><a href="##">唐熠达</a></li>
									<li><a href="##">陶&nbsp;凌</a></li>
									<li><a href="##">田小利</a></li>
									<li><a href="##">汪道文</a></li>
									<li><a href="##">王春生</a></li>
									<li><a href="##">王&nbsp;浩</a></li>
									<li><a href="##">王红月</a></li>
									<li><a href="##">王宏宇</a></li>
									<li><a href="##">王继光</a></li>
									<li><a href="##">王建安</a></li>
									<li><a href="##">王乐丰</a></li>
									<li><a href="##">王乐民</a></li>
										<li class="contLi">
										<a href="##" style="color:#3393e7">吴永健</a>
										<ul style="position: absolute;top: 59%;left:15%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451085468489539607947.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=18" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/yongjian-wu/542cf2e7dabfae489b977703" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">王&nbsp;蒨</a></li>
									<li><a href="##">王&nbsp;巍</a></li>
									<li><a href="##">王伟鹏</a></li>
									<li><a href="##">王&nbsp;文</a></li>
									<li><a href="##">王&nbsp;焱</a></li>
									<li><a href="##">王增武</a></li>
									<li><a href="##">魏英杰</a></li>
									<li><a href="##">吴海英</a></li>
									<li><a href="##">吴&nbsp;明</a></li>
									<li><a href="##">吴寿岭</a></li>
									<li><a href="##">吴学思</a></li>
								
									<li><a href="##">伍贵富</a></li>
									<li><a href="##">武阳丰</a></li>
									<li><a href="##">夏云龙</a></li>
									<li><a href="##">肖明第</a></li>
									<li><a href="##">熊&nbsp;辉</a></li>
									<li><a href="##">徐&nbsp;波</a></li>
									<li><a href="##">许顶立</a></li>
									<li><a href="##">许建屏</a></li>
									<li><a href="##">顼志敏</a></li>
									<li><a href="##">严&nbsp;激</a></li>
									<li><a href="##">严晓伟</a></li>
									<li><a href="##">颜红兵</a></li>
									<li><a href="##">杨杰孚</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">杨进刚</a>	
										<ul style="position: absolute;top: 69%;left:62%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370459178862521803968398.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=91" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/jingang-yang/54084cfcdabfae450f409d9e" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>	
									</li>
									<li><a href="##">杨丽霞</a></li>
									<li><a href="##">杨&nbsp;萍</a></li>
									<li><a href="##">杨天和</a></li>
									<li><a href="##">杨天伦</a></li>
									<li><a href="##">杨新春</a></li>
									<li><a href="##">杨艳敏</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">杨跃进</a>
										<ul style="position: absolute;top: 74%;left:4%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451097189838057934837.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=11" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/yuejin-yang/542f82c6dabfae3f1d5998f3" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">姚&nbsp;焰</a></li>
									<li><a href="##">叶&nbsp;平</a></li>
									<li><a href="##">于&nbsp;波</a></li>
									<li><a href="##">俞梦越</a></li>
									<li><a href="##">袁晋青</a></li>
									<li><a href="##">袁祖贻</a></li>
									<li><a href="##">张福春</a></li>
									<li><a href="##">张海波</a></li>
									<li><a href="##">张海澄</a></li>
									<li><a href="##">张&nbsp;浩</a></li>
									<li><a href="##">张&nbsp;健</a></li>
									<li><a href="##">张抒扬</a></li>
									<li><a href="##">张&nbsp;澍</a></li>
									<li><a href="##">张&nbsp;运</a></li>
									<li><a href="##">张&nbsp;钲</a></li>
									<li><a href="##">赵&nbsp;冬</a></li>
									<li><a href="##">赵连成</a></li>
									<li><a href="##">赵&nbsp;强</a></li>
									<li><a href="##">赵世华</a></li>
									<li><a href="##">赵兴胜</a></li>
									<li><a href="##">甄文俊</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">郑&nbsp;哲</a>
										<ul style="position: absolute;top: 84%;left:33%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451126913537994027376.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=72" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/zhe-zheng/53f4bf4edabfaedce877b58f" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">周宪梁</a></li>
									<li class="contLi">
										<a href="##" style="color:#3393e7">周玉杰</a>
										<ul style="position: absolute;top: 84%;left:45%;">
											<li style="background:url('http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449644256974347498146.png')">
												<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370451110057031353525083.jpg" alt="">
												<a href="http://academiclifepc.boyuancb.com/#/?expertId=73" class="autosacde" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449725971470843304427.png" alt=""><br><span>学术人生</span>
												</a>
												<a href="https://www.aminer.cn/profile/yujie-zhou/53f78d6edabfae90ec105a7f" class="autosacdeB" target="_blank">
													<img src="http://uniappfile.boyuancb.com/UploadFile/SiteNotice/Images/6370449728982020349638492.png" alt=""><br><span>学者画像</span>
												</a>
											</li>
										</ul>
									</li>
									<li><a href="##">周&nbsp;洲</a></li>
									<li><a href="##">朱&nbsp;俊</a></li>
									<li><a href="##">朱天刚</a></li>
									<li><a href="##">朱文玲</a></li>
									<li><a href="##">祝之明</a></li>
									<li><a href="##">庄&nbsp;建</a></li>
									<li><a href="##">邹云增</a></li>
									<div style="clear: both;"></div>
								</ul>
							</div>
							<div class="divContentCont">
								<p>通讯编委</p>
								<ul>
									<li><a href="##">曹慧青</a></li>
									<li><a href="##">丁荣晶</a></li>
									<li><a href="##">樊晓寒</a></li>
									<li><a href="##">冯&nbsp;雪</a></li>
									<li><a href="##">高&nbsp;展</a></li>
									<li><a href="##">华&nbsp;潞</a></li>
									<li><a href="##">贾&nbsp;楠</a></li>
									<li><a href="##">李翠兰</a></li>
									<li><a href="##">李汇华</a></li>
									<li><a href="##">刘梅颜</a></li>
									<li><a href="##">鲁梅花</a></li>
									<li><a href="##">马玉良</a></li>
									<li><a href="##">欧阳晨曦</a></li>
									<li><a href="##">沈晨阳</a></li>
									<li><a href="##">史旭波</a></li>
									<li><a href="##">宋&nbsp;雷</a></li>
									<li><a href="##">孙艺红</a></li>
									<li><a href="##">王贵松</a></li>
									<li><a href="##">王来元</a></li>
									<li><a href="##">王胜煌</a></li>
									<li><a href="##">吴&nbsp;钢</a></li>
									<li><a href="##">邢小燕</a></li>
									<li><a href="##">熊长明</a></li>
									<li><a href="##">杨克明</a></li>
									<li><a href="##">杨&nbsp;清</a></li>
									<li><a href="##">叶&nbsp;涛</a></li>
									<li><a href="##">余再新</a></li>
									<li><a href="##">张海锋</a></li>
									<li><a href="##">张&nbsp;力</a></li>
									<li><a href="##">张伟丽</a></li>
									<li><a href="##">张瑶俊</a></li>
									<li><a href="##">张宇辉</a></li>
									<li><a href="##">郑金刚</a></li>
									<li><a href="##">周京敏</a></li>
									<div style="clear: both;"></div>
								</ul>
							</div>
					</div>
									</div>

									</div>

      </div>
      <div class="editorial_right">
        <advertisement :num="num" :list2="list2"></advertisement>
      </div>
    </div>
  </div>
</template>

<script>

//配置右侧广告栏
import advertisement from "../public/evolution/advertisement.vue"


export default {
  
  components:{
    advertisement
  },
  data () {
    return {
      curr: 1,//当前页数
      limit: 10,
      total: 0,//总条数
      num:{
        wai: false,
        zixun: true,
        xia: true,
        look: false,
        video2: true,
      },//控制广告栏的显示隐藏
      list: [],
      list2: [
        {
          id: 1,
          txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
        },
        {
          id: 2,
          txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
        }
      ],//外科天地
      list3:[],
    }
  },

  methods:{
  
    show(n)
      {
          document.getElementById(n).style.display="block";
      },
    hide(n)
      {
          document.getElementById(n).style.display="none";
      },
      tiao(){
        this.$router.push({path:'/home'});
      },

      //获取网站 首页模块信息 / 点击栏目得到的数据信息
      GetHomePageBlockInfo(channelId){
        var that = this;
        that.$httphelper.GetHomePageBlockInfo({
          journalId: 201607080003,
          "pChannelId": 0,
          "channelId": channelId,
          "jChannelID": 0,
          "dataSourceType": 1,
          "dataShowType": 1,
          "curr": that.curr,
          "limit": that.limit,
        }).then(res => {
          if(res.code==200){
            that.list = res.data || '';
            that.total = res.totalcount;
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },


      getXq(){
          var  that=this
         that.$httphelper.GetContentInfo({
          "journalId": 201607080003,
          "year":  0,
          "issue": 0,
          "channelId": 2937,
          "contentId": 169167,
          "dataSourceType": 1,
          "dataShowType": 1
        }).then(res => {
          if(res.code==200){
            that.list3=res.data.siteContentInfoResult
            that.$loading.hideLoading();
          }else{
            that.$alert(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        });
      },

      jump(num,contentId){
        this.$router.push({path:'/expert_details',query:{num: num,contentId: contentId}});
      },

      index(){
        this.GetHomePageBlockInfo(2937);
        this.getXq()
        this.total = this.list.length;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.curr = val;
        this.GetHomePageBlockInfo(2937);
        console.log(`当前页: ${val}`);
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].contentId){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
*{
    margin: 0;
    padding: 0;
}
.editorial{
  width: 100%;
  min-width: 1366px;
  background-color: #FFFFFF;
  .pBt{
	 	width: 627px;
	    height: 30px;
	    line-height: 30px;
	    padding: 0 0 0 20px;
	    font-size: 16px;
	    font-family: 'Microsoft Yahei';
	    color: #FFF;
	    background: #7d7d7e;
	 }
	 .pBtbianwei{
	 	width: 100%;
	 	text-align: center;
	 	color: rgb(0, 128, 128);
		margin-top:20px;
		font-size:20px;
		font-weight:bold;
	 }
	 .divContentCont{
	 	width: 100%;
	 	height: 100%;
	 	position: relative;
		margin-bottom:30px;
	 }
	 .divContentCont p{
	 	text-align: left;
	 	font-size: 18px;
	 	font-weight: bold;
	 }
	 .divContentCont ul{
	 	width: 100%;
	 	padding-left: 1px;
		margin-top:10px;
	 }
	 .divContentCont ul li{
	 	list-style: none;
	 	float: left;
	 	margin-right: 21px;
	 	margin-bottom: 10px;
	 }
	 .divContentCont ul li a{
 	    color: #000;
	    text-decoration: none;
	    cursor: pointer;
	    font-size: 16px;
	 }
	 .divContentCont > ul > li > ul{
		width:42%!important;
	 	display: none;
	 	position: absolute;
	 	z-index: 999;
	 }
	 .divContentCont > ul .contLi:hover ul{
		display: block;
	 }
	 .divContentCont > ul > li > ul > li{
	 	width:255px;
	 	height:243px;
	 	background-size: cover;
	 	position: relative;
	 }
	 .divContentCont > ul > li > ul > li > img{
		position: absolute;
		top: 12px;
		left:25px;
	 }
	 .divContentCont > ul > li > ul > li a{
	 	width: 70px;
	 	height: 71px;
	 }
	 .divContentCont > ul > li > ul > li .autosacde{
	 	position: absolute;
	 	top: 41px;
	 	right: 0;
	 }
	 .divContentCont > ul > li > ul > li .autosacde img{
	 	width: 38px;
	 	height: 38px;
     margin-left: 10px;
	 	position: relative;
	 }
	 .divContentCont > ul > li > ul > li .autosacde span{
	 	font-size: 14px;
	    	font-weight: bold;
	    	color: #000;
	    	text-align: center;
	    	position: relative;
    		left: 6px;	
		top:-13px;
	}
	.divContentCont > ul > li > ul > li .autosacde:hover span{	
		color:#DD0514;
	}
	.divContentCont > ul > li > ul > li .autosacdeB:hover span{	
		color:#DD0514;
	}
	.divContentCont > ul > li > ul > li .autosacdeB{
	 	position: absolute;
	 	top: 143px;
	 	right: 0;
	 }
	 .divContentCont > ul > li > ul > li .autosacdeB img{
	 	width: 38px;
	 	height: 38px;
     margin-left: 10px;
	 	position: relative;
	 }
	 .divContentCont > ul > li > ul > li .autosacdeB span{
	 	font-size: 14px;
	 	font-weight: bold;
	 	color: #000;
	 	text-align: center;
	 	position: relative;
	 	left: 6px;
		top:-13px;
	}
  .editorial_nav{
    width: 85%;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 24px;
    .editorial_txt{
      width: 100%;
      margin-bottom: 26px;
      overflow: hidden;
      .evolution_tu{
        width: 19px;
        height: 17px;
        float: left;
      }
      .editorial_txt2{
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #010101;
        .span1 {
          margin: 0 5px;
        }
        .span2 {
          color: var(--xt);
        }
      }
    }
    .editorial_left{
      width: 72%;
      margin-right: 3%;
      float: left;
      .express_rtitle {
        width: 100%;
        overflow: hidden;
        border-bottom: 3px solid #DBDBDB;
        padding-bottom: 11px;
        position: relative;
        .waike {
          width: 50%;
          float: left;
          font-size: 20px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #000000;
          line-height: 23px;
        }
        .waixian {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100px;
          height: 3px;
          background: var(--biao);
        }
      }
      .express_nav2r {
        width: 100%;
        overflow: hidden;
        margin-top: 29px;

        .express_list2 {
          width: 100%;
          overflow: hidden;
          cursor: pointer;
          margin-bottom: 12.3px;
          border-bottom: 1px solid #EBEBEB;
          line-height: 62px;
          .express_dian {
            width: 10px;
            height: 10px;
            background: #DBDBDB;
            border-radius: 50%;
            margin-right: 15px;
            float: left;
            margin-top: 27px;
          }

          .express_wen {
            width: 91%;
            float: left;

            .wen1 {
              width: 100%;
              font-size: 16px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;


              .span3 {
                width: 80%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                float: left;
              }
            }

            .wen2 {
              width: 100%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              margin-bottom: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }

          .zhai {
            width: 90%;
            padding-left: 31px;
            overflow: hidden;
            float: left;

            .wen3 {
              width: 50%;
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #636363;
              float: left;
            }

            .zhai_left,
            .zhai_right {
              font-size: 14px;
              font-family: Adobe Heiti Std;
              font-weight: normal;
              color: #000000;
              float: right;
            }

            .zhai_right {
              margin-left: 30px;
            }

            .zhai_left:hover {
              text-decoration: underline;
              color: var(--biao);
            }

            .zhai_right:hover {
              text-decoration: underline;
              color: var(--biao);
            }
          }
        }
      }
      .el-pagination{
        text-align: center;
        margin-top: 30px;
      }
    }
    .editorial_right{
      width: 25%;
      float: left;
    }
  }
}
.add1 {
  color: var(--xt) !important;
  text-decoration: underline;
}

.add2 {
  background-color: var(--xt) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/editorial.vue